var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { request } from '../request';
import { getQuery } from '@tencent/multi-url';
var reqUrl = '/node/common/log/report';
var reportCount = 0;
export var reportStatistics = function (option, needCache) {
    if (needCache === void 0) { needCache = true; }
    var reportOption = [];
    if (!Array.isArray(option)) {
        reportOption = [option];
    }
    else {
        reportOption = option;
    }
    if (reportOption.length === 0) {
        return false;
    }
    // 注意pv上报的时候 因为用的是beforeRouter 所以window.location.href这时候取到的还取不到即将去到的to的hash,不能直接用urlObj.hash
    var urlObj = new URL(window.location.href);
    var basePage = "".concat(urlObj.origin).concat(urlObj.pathname);
    var privateInfo = reportOption.map(function (item) {
        reportCount = reportCount + 1;
        var curHash = (item.hash ? "#".concat(item.hash) : urlObj.hash || '').toLocaleLowerCase();
        var hashQueryIndex = curHash.indexOf('?');
        var hash = hashQueryIndex >= 0 ? curHash.substr(0, hashQueryIndex) : curHash;
        var virUrl = "".concat(urlObj.origin).concat(curHash.substr(1)); // 去掉hash上的# 构造一个url 取出hash上的query参数
        var actTag = getQuery('activeTag', virUrl) ||
            getQuery('activeTag') ||
            getQuery('adtag', virUrl) ||
            getQuery('adtag'); // hash上的tag优先
        return {
            pageId: item.pageId || "".concat(basePage).concat(hash) || '',
            reportType: 'statistics',
            uri: window.location.href,
            extraMsg: item.extraMsg || '',
            activeTag: item.activeTag || actTag,
            evtName: item.evtName || '',
            num: item.num === undefined ? '1' : item.num,
            desc: item.desc || '',
            ext1: item.ext1 || '',
            ext2: item.ext2 || '',
            ext3: item.ext3 || '',
            ext4: item.ext4 || '',
            seq: reportCount,
            number1: item.number1,
            number2: item.number2,
            number3: item.number3,
            number4: item.number4,
        };
    });
    return reportStatisticsRaw(privateInfo, needCache);
};
var reportDatas = [];
var reportHandle = null;
export var reportStatisticsRaw = function (options, needCache) {
    if (needCache === void 0) { needCache = false; }
    var defaulOptions = {
        source: 'h5',
    };
    var assignOptions = options.map(function (item) {
        return __assign(__assign({}, defaulOptions), item);
    });
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!needCache) return [3 /*break*/, 1];
                    reportDatas = reportDatas.concat(assignOptions);
                    clearTimeout(reportHandle);
                    reportHandle = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var reportStr, err_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(reportDatas.length > 0)) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    reportStr = JSON.stringify(reportDatas);
                                    reportDatas = [];
                                    return [4 /*yield*/, sendReport(reqUrl, JSON.parse(reportStr))];
                                case 2:
                                    _a.sent();
                                    resolve(true);
                                    return [3 /*break*/, 4];
                                case 3:
                                    err_2 = _a.sent();
                                    resolve(false);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }, 500);
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendReport(reqUrl, assignOptions)];
                case 2:
                    _a.sent();
                    resolve(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    resolve(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
};
export var reportLog = function (options) {
    var urlObj = new URL(window.location.href);
    var hashQueryIndex = urlObj.hash.indexOf('?');
    // https://www.infiniumbank.com/walletBind/?dev=1&token=101001202012212970050046#/status?xxxx=122 取到到hash是 #/status?xxxx=122
    var hash = hashQueryIndex >= 0 ? urlObj.hash.substr(0, hashQueryIndex) : urlObj.hash;
    hash = hash ? hash.toLocaleLowerCase() : '';
    var basePage = "".concat(urlObj.origin).concat(urlObj.pathname);
    // const curHash = options.hash ? options.hash : urlInfo.hash;
    var defaulOptions = {
        source: 'h5Error',
        transparent: 1,
        uri: window.location.href,
        reportType: 'common',
        time: parseInt("".concat(Date.now() / 1000), 10),
        pageId: "".concat(basePage).concat(hash) || '',
    };
    var assignOptions = __assign(__assign({}, defaulOptions), options);
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendReport(reqUrl, assignOptions)];
                case 1:
                    _a.sent();
                    resolve(true);
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    resolve(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
var sendReport = function (url, data) {
    if (data === void 0) { data = {}; }
    if (navigator.sendBeacon) {
        var blob = new Blob([JSON.stringify({ data: data })], {
            type: 'application/json; charset=UTF-8',
        });
        return navigator.sendBeacon(url, blob);
    }
    return request({ url: reqUrl, method: 'POST', data: { data: data } });
};
